import {Request} from './Request';
import {UpdateType} from '../enums/update.type.enum';

export class SendLocalListRequest implements Request {
    chargePointSelectList: string[];
    private listVersion: number;
    private updateType: UpdateType;
    private sendEmptyListWhenFull: boolean;
    private deleteList: string[];
    private addUpdateList: string[];

    constructor(chargePointSelectList: string[], listVersion?: number, updateType?: UpdateType, sendEmptyListWhenFull?: boolean,
                deleteList?: string[], addUpdateList?: string[]) {
        this.chargePointSelectList = chargePointSelectList;
        this.listVersion = listVersion;
        this.updateType = updateType;
        this.sendEmptyListWhenFull = !!sendEmptyListWhenFull  ? sendEmptyListWhenFull : false;
        this.deleteList = deleteList;
        this.addUpdateList = addUpdateList;
    }

    public toString = (): string => {
        return `SendLocalListRequest (chargePointSelectList: ${this.chargePointSelectList},
        listVersion: ${this.listVersion}, updateType: ${this.updateType},
        sendEmptyListWhenFull: ${this.sendEmptyListWhenFull},
        deleteList: ${this.deleteList},
        addUpdateList: ${this.addUpdateList})`;
    }


    get list_version(): number {
        return this.listVersion;
    }

    set list_version(value: number) {
        this.listVersion = value;
    }

    get update_type(): UpdateType {
        return this.updateType;
    }

    set update_type(value: UpdateType) {
        this.updateType = value;
    }

    get _sendEmptyListWhenFull(): boolean {
        return this.sendEmptyListWhenFull;
    }

    set _sendEmptyListWhenFull(value: boolean) {
        this.sendEmptyListWhenFull = value;
    }

    get delete_list(): string[] {
        return this.deleteList;
    }

    set delete_list(value: string[]) {
        this.deleteList = value;
    }

    get _addUpdateList(): string[] {
        return this.addUpdateList;
    }

    set _addUpdateList(value: string[]) {
        this.addUpdateList = value;
    }
}

/*
chargePointSelectList: JSON;EVB-P20261797;-
chargePointSelectList: 1
listVersion: 4
updateType: FULL
addUpdateList: 1
deleteList: 1
sendEmptyListWhenFull: on



chargePointSelectList: JSON;EVB-P20261797;-
chargePointSelectList: 1
listVersion: 4
updateType: DIFFERENTIAL
addUpdateList: 04B0267AE05C87
addUpdateList: 1
deleteList: 123456789
deleteList: 1
sendEmptyListWhenFull: on
csrf: 7f448777-54a3-4050-8ec1-9c696b0d47ef


 */
